import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule)
  },
  {
    path: '',
    redirectTo: 'splash',
    pathMatch: 'full'
  },
  {
    path: 'splash',
    loadChildren: () => import('./pages/splash/splash.module').then(m => m.SplashPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'menu',
    loadChildren: () => import('./pages/menu/menu.module').then(m => m.MenuPageModule)
  },
  {
    path: 'trabajos',
    loadChildren: () => import('./pages/trabajos/trabajos.module').then(m => m.TrabajosPageModule)
  },
  {
    path: 'inspecciones',
    loadChildren: () => import('./pages/inspecciones/inspecciones.module').then(m => m.InspeccionesPageModule)
  },
  {
    path: 'pagar-planilla',
    loadChildren: () => import('./pages/pagar-planilla/pagar-planilla.module').then( m => m.PagarPlanillaPageModule)
  },
  {
    path: 'portal-clientes',
    loadChildren: () => import('./pages/portal-clientes/portal-clientes.module').then(m => m.PortalClientesPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
